import config from '../../config';

// When a logged-in customer clicks Enquire on a tester with enquiries off, the
// tester still gets a normal enquiry, sent from the customer's account, so they
// can reply from their inbox and know enquiries are worth turning back on.
export const pausedEnquiryMessage = customerName =>
  `Automatic message: ${customerName} tried to enquire about one of your packages, but your enquiries are turned off. ` +
  `You can reply to ${customerName} here in your inbox. ` +
  `To get enquiries again, turn them back on in Account settings → Enquiries: ${config.canonicalRootURL}/account/enquiries`;

// Each customer sends one automatic enquiry per tester a week, however many
// times they reopen the modal.
const RESEND_AFTER_MS = 7 * 24 * 60 * 60 * 1000;
const storageKey = (customerId, listingId) => `pausedEnquirySent:${customerId}:${listingId}`;

export const wasPausedEnquirySent = (customerId, listingId, now = Date.now()) => {
  try {
    const sentAt = Number(window.localStorage.getItem(storageKey(customerId, listingId)));
    return sentAt > 0 && now - sentAt < RESEND_AFTER_MS;
  } catch (e) {
    return false;
  }
};

export const rememberPausedEnquirySent = (customerId, listingId, now = Date.now()) => {
  try {
    window.localStorage.setItem(storageKey(customerId, listingId), String(now));
  } catch (e) {
    // Without storage the guard only lasts for this page view.
  }
};
